/**
 * Tenancy Routes
 *
 * Route definitions for the tenancies module.
 */

import { lazy } from 'react';

const TenancyManagement = lazy(() => import('@/pages/tenancies/TenancyManagement'));
const TenancyDetailLayout = lazy(() => import('@/pages/tenancies/TenancyDetailLayout'));
const TenancyOverview = lazy(() => import('@/pages/tenancies/TenancyOverview'));
const TenancyContracts = lazy(() => import('@/pages/tenancies/TenancyContracts'));
const TenancyBKA = lazy(() => import('@/pages/tenancies/TenancyBKA'));
const TenancyFinancial = lazy(() => import('@/pages/tenancies/TenancyFinancial'));
const TenancyTransactions = lazy(() => import('@/pages/tenancies/TenancyTransactions'));
const TenancyInvoices = lazy(() => import('@/pages/tenancies/TenancyInvoices'));
const TenancyDocuments = lazy(() => import('@/pages/tenancies/TenancyDocuments'));
const TenancyRentArrearsNotices = lazy(() => import('@/pages/tenancies/TenancyRentArrearsNotices'));

export const tenancyRoutes = [
    {
        path: 'tenancies',
        element: <TenancyManagement />,
    },
    {
        path: 'tenancies/:id',
        element: <TenancyDetailLayout />,
        children: [
            { index: true, element: <TenancyOverview /> },
            { path: 'overview', element: <TenancyOverview /> },
            { path: 'contracts', element: <TenancyContracts /> },
            { path: 'bka', element: <TenancyBKA /> },
            { path: 'financial', element: <TenancyFinancial /> },
            { path: 'transactions', element: <TenancyTransactions /> },
            { path: 'invoices', element: <TenancyInvoices /> },
            { path: 'documents', element: <TenancyDocuments /> },
            { path: 'rent-arrears-notices', element: <TenancyRentArrearsNotices /> },
        ],
    },
];
